import { useState, useRef, useEffect } from "react";
import eventImage from "../img/Banner/madurai.jpeg";

const AnnouncementBar = () => {
    const [open, setOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const marqueeRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <>
            <div
                style={{
                    background: "#D0021B",
                
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    maxWidth: "1200px",
                    margin: "0 auto",
                    padding: isMobile ? "6px 10px" : "",
                    boxSizing: "border-box",
                }}

                className="announcement-main"
            >
                {/* Marquee */}
                <div style={{ flex: 1, overflow: "hidden" }}>
                    <marquee
                        ref={marqueeRef}
                        behavior="scroll"
                        direction="left"
                        scrollAmount={isMobile ? "4" : "8"}
                        onMouseOver={() => marqueeRef.current?.stop()}
                        onMouseOut={() => marqueeRef.current?.start()}
                        style={{
                            fontWeight: 700,
                            fontSize: isMobile ? "12px" : "16px",
                         
                        }}
                    >
                        Tiara Software is displaying a stall at Maditssia’s Print Pack 2026 event happening on coming Fri, July 24 - Sun, July 26 at Madurai Velammal Medical College. Please come and visit us at stall D14.
                    </marquee>
                </div>

                {/* Fixed Link */}
                <span
                    onClick={() => setOpen(true)}
                    style={{
                        marginLeft: "12px",
                        color: "#FFD700",
                        fontWeight: "bold",
                        textDecoration: "underline",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                        fontSize: isMobile ? "12px" : "15px",
                    }}
                >
                    More Details →
                </span>
            </div>

            {/* Modal */}
            {open && (
                <div
                    onClick={() => setOpen(false)}
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.75)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "20px",
                        zIndex: 9999,
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: "relative",
                            maxWidth: isMobile ? "95vw" : "800px",
                            width: "100%",
                        }}
                    >
                        {/* Close Button */}
                        <button
                            onClick={() => setOpen(false)}
                            style={{
                                position: "absolute",
                                top: "-15px",
                                right: "-15px",
                                width: "36px",
                                height: "36px",
                                borderRadius: "50%",
                                border: "none",
                                background: "#fff",
                                color: "#000",
                                fontSize: "22px",
                                fontWeight: "bold",
                                cursor: "pointer",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                            }}
                        >
                            ×
                        </button>

                        {/* Image */}
                        <img
                            src={eventImage}
                            alt="Print Pack 2026"
                            style={{
                                width: "100%",
                                maxHeight: "85vh",
                                objectFit: "contain",
                                borderRadius: "10px",
                                display: "block",
                                background: "#fff",
                            }}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default AnnouncementBar;